import{WithKiteComponentTrackingForNormal as o}from"@kite-js/core";import{L as t}from"./Logo-870b7df6.js";import"react";import"@kite-js/theme";import"styled-components";var r=o(t,"Logo",!0);export{r as Logo};
